import Globe from '../src/Globe';
export default Globe;
